/**
 * Labstep
 */

import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { FilterDeletedActiveProps } from './types';

export const FilterDeletedActive: React.FC<
  FilterDeletedActiveProps
> = ({ clearParams, searchParams }) => {
  if (searchParams.is_deleted || searchParams.is_user_deleted) {
    return (
      <RemoveLabel
        icon={searchParams.is_deleted ? 'trash' : 'ban'}
        name={searchParams.is_deleted ? 'Deleted' : 'Disabled'}
        onRemoveClick={
          clearParams &&
          ((): void => clearParams(['is_deleted', 'is_user_deleted']))
        }
      />
    );
  }
  return null;
};
